import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService, mfaRequiredSchema } from 'src/app/shared/services/auth/auth.service';
import { UsersService } from '../users/users.service';
import { AxiosError } from 'axios';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  private router = inject(Router);
  private authService = inject(AuthService);
  private usersService = inject(UsersService);

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    let user = this.usersService.userSubject.value;
    if (user) {
      if (user.email_verified) {
        this.authService.setNext(null);
        return true;
      }

      if (state.url === '/verify-email') {
        return true;
      } else {
        return this.router.navigateByUrl('verify-email');
      }
    }

    this.authService.setNext(state.url);

    this.authService.logoutOnUnauthorized = false;
    try {
      user = await this.usersService.setUser();
      if (user.email_verified) {
        this.authService.setNext(null);
        return true;
      }

      if (state.url === '/verify-email') {
        return true;
      } else {
        return this.router.navigateByUrl('verify-email');
      }
    } catch (error) {
      if (error instanceof AxiosError && mfaRequiredSchema.safeParse(error.response?.data).success) {
        this.authService.logoutOnUnauthorized = true;
        return this.router.navigateByUrl('2fa/verify');
      }
    }

    try {
      if (await this.tryLoginWithShortToken(route)) {
        await this.usersService.setUser();
        this.authService.setNext(null);
        this.authService.logoutOnUnauthorized = true;
        return true;
      }
    } catch {
      //
    }

    this.authService.logoutOnUnauthorized = true;

    return this.router.navigateByUrl('login');
  }

  private async tryLoginWithShortToken(route: ActivatedRouteSnapshot): Promise<boolean> {
    const shortToken = route.queryParams.short_token;
    if (!shortToken) {
      return false;
    }

    try {
      await this.authService.loginWithShortToken(shortToken);
      return true;
    } catch {
      return false;
    }
  }
}
